var React = require('react');

function UIIconsPfeilWeiß (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"62.35 24.59 87.77 50 62.35 75.41","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"6px"},"key":0}),React.createElement("line",{"x1":"12.23","y1":"50","x2":"87.77","y2":"50","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"6px"},"key":1})]);
}

UIIconsPfeilWeiß.defaultProps = {"id":"Ebene_1","data-name":"Ebene 1","viewBox":"0 0 100 100"};

module.exports = UIIconsPfeilWeiß;

UIIconsPfeilWeiß.default = UIIconsPfeilWeiß;
